'use strict';

// ---------------- ATTENTION ----------------
// requireJs 不支持 preload 机制，依赖 fis 的 depsPack 机制，使得任意业务 js 都在 global 完成后执行(包括内部依赖)
// 严格意义上来说，时序不严谨正确
// 下方代码，总是在业务 js 执行前执行。注意 amd 的执行时序可能会引发预期外行为
// -------------------------------------------


// 加载头尾基础功能，即使不使用(即，视为全局脚本)
require(['lib/require-css-0.1.10/css', 'component/lazyload', 'global/head_nav/index', 'global/bottom_about/index', 'component/io', 'global/service/langService', 'lib/js-cookie-2.1.4/js.cookie'], function (css, lazyload, HeadNav, BottomAbout, IO, LangService, Cookie) {
  'use strict';

  var sentryUserId = Cookie.get('sentry_user_id');
  var sentryUserEmail = Cookie.get('sentry_user_email');

  LangService.init();
  if (!true) {
    // 非 DEV 模式时，component 样式已合并打包，强行关闭加载功能
    var cssLoadRef = css.load;
    css.load = function proxy(cssId, req, load, config) {
      if (cssId.indexOf('component') !== -1) {
        load('');
        return undefined;
      } else {
        return cssLoadRef.apply(this, arguments);
      }
    };
  }
  if (window.location.href.includes('sign.pkfare')) {
    Sentry.setUser({
      id: sentryUserId,
      email: sentryUserEmail
    });
  }

  // 页面加载时，立即处理一次 lazyload
  lazyload($('.fn-lazyload'));

  // 由是否加载渲染节点，判断是否使用头尾基础功能
  if ($('#global_head_nav').length) {
    HeadNav.init();
  }
  if ($('#global_bottom_about').length) {
    BottomAbout.init();
  }

  // 挂载 IO，方便调试
  window.IO = IO;
});